// @ts-nocheck
import { useEffect, useState } from 'react';
import { useAtomValue } from 'jotai';
import { dcbAtom } from '@shared/store/slice-atoms';

export const useConfirmationPrice = () => {
  const { subscribeData, homeData, operator } = useAtomValue(dcbAtom);
  const [finalText, setFinalText] = useState('');

  useEffect(() => {
    if (subscribeData.billingOption && operator) {
      const textData = homeData.operators.find(
        (operatorItem) => operatorItem.name === operator?.name
      );
      if (textData) {
        const text = textData[`${subscribeData?.billingOption}Text`];
        if (text) {
          setFinalText(text);
        }
      }
    }
  }, [homeData, subscribeData.billingOption, operator]);

  return finalText;
};
